const FETCH_SEANCES = 'fetch_seances';
const FETCH_CALENDAR_SEANCE = 'fetch_calendar_seances';
const FETCH_UNCONFIRMED_SEANCES = 'fetch_unconfirmed_seances';
const FETCH_SEANCE = 'fetch_seance';
const FETCH_SEANCES_CSV = 'fetch_seance_csv';
const DELETE_SEANCE = 'delete_seance';
const PERSIST_SEANCE = 'persist_seance';
const FETCH_SEANCE_STATISTICS = 'seance_statistics';
const FETCH_FILES_SEANCE = 'fetch_seance_files';
const DELETE_FILE_SEANCE = 'delete_seance_file';
const CREATE_FILES_SEANCE = 'create_seances_file';
const MOVE_TO_OCCASION_SEANCE = 'update_to_occasion_seances';
const SIGN_SEANCE = 'sign_seances';
const COPY_NOTE_SEANCE = 'copy_note_seances';
const UPDATE_SEANCE = 'update_seances';
const FETCH_MULTI_SEANCE = 'fetch_multi_seances';
const UPDATE_SEANCE_NOTE = 'update_seance_note';
const UPDATE_SEANCE_IN_TIME = 'update_seance_in_time';
const UPDATE_LOCATION = 'update_location';
const FETCH_SEANCES_LIST = 'fetch_seance_list';

export default {
    FETCH_SEANCES,
    FETCH_SEANCES_LIST,
    FETCH_SEANCES_CSV,
    FETCH_UNCONFIRMED_SEANCES,
    FETCH_SEANCE,
    FETCH_CALENDAR_SEANCE,
    DELETE_SEANCE,
    PERSIST_SEANCE,
    FETCH_FILES_SEANCE,
    DELETE_FILE_SEANCE,
    CREATE_FILES_SEANCE,
    SIGN_SEANCE,
    COPY_NOTE_SEANCE,
    UPDATE_SEANCE,
    UPDATE_LOCATION,
    FETCH_MULTI_SEANCE,
    MOVE_TO_OCCASION_SEANCE,
    FETCH_SEANCE_STATISTICS,
    UPDATE_SEANCE_NOTE,
    UPDATE_SEANCE_IN_TIME,
};
